@if (loading) {
    <app-loader />
} @else {
    @if (discrepancies.length <= 0) {
        <span class="text-light text-med color-status-red4 error-text"
            >An error occurred while loading the discrepancies, please try in
            some time.</span
        >
    } @else {
        <app-tabs
            tabLabelClass="text-s"
            tabContentClass="ml-n4 pl-4"
            [tabs]="tabsData"
            [syncWithRouter]="isDetailMode"
            [initialSelectedTabIndex]="selectedTabIndex"
            (tabSelected)="handleTabChange($event)">
            @if (isDetailMode) {
                <router-outlet />
            } @else {
                @if (selectedDiscrepancy) {
                    <app-discrepancy-details
                        [id]="selectedDiscrepancy"
                        [documentId]="documentId" />
                }
            }
            @if (isDetailMode) {
                <div style="height: 25px"></div>
                <app-document-upload [documentId]="documentId" />
            }
            @if (isDetailMode && maxDiscrepancyCount) {
                <app-add-discrepancy-button
                    headerContent
                    class="ml-auto mr-4 mb-2"
                    [disabled]="!canAddDiscrepancy"
                    [maxDiscCount]="maxDiscrepancyCount"
                    (addClicked)="onAddClicked()" />
            }
        </app-tabs>
    }
}
